
import { Component, Mixins, Prop } from "vue-property-decorator";
import Select from "./Select.vue";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import { getModule } from "vuex-module-decorators";
import SystemModule from "@/store/modules/system";

const systemModuleState = getModule(SystemModule);

@Component({
  components: {
    Select
  }
})
export default class UnitOfMeasureSelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  localUnitsOfMeasure: any[] = [];
  unitsOfMeasure: any[] = null;

  @Prop({ default: null, required: true })
  public type: string;

  @Prop({ default: false })
  public preload: true;

  async created() {
    if (this.preload) {
      let results = await systemModuleState.getUnitsOfMeasure(this.type, null);
      this.localUnitsOfMeasure = results.map(x => ({ label: x.id, value: x.id }));
    }
  }

  async search(value, loading) {
    if (this.preload) return;
    loading(true);
    try {
      let results = await systemModuleState.getUnitsOfMeasure(this.type, value);

      this.unitsOfMeasure = results.map(x => ({ label: x.id, value: x.id }));
    } finally {
      loading(false);
    }
  }

  get items() {
    if (this.unitsOfMeasure) return this.unitsOfMeasure;
    return this.localUnitsOfMeasure;
  }
}
